import React from 'react';

import { SmartCardProvider } from '@atlaskit/link-provider/smart-card-provider';
import { Stack } from '@atlaskit/primitives/compiled';

import { RecentWorkItem } from './RecentWorkItem';

const DEFAULT_MAX_SOURCES = 3;

interface RecentWorkListProps {
	/** Smart-link URLs to render, newest first. */
	urls: string[];
	/** Max number of rows shown. Defaults to 3. */
	maxSources?: number;
	/** Fired when an individual recent-work row is clicked. */
	onLinkClick?: (url: string, index: number) => void;
	testId?: string;
}

/**
 * Borderless list of the profiled user's recent work.
 *
 * 1. Caps the URLs at `maxSources` and renders each as a borderless {@link RecentWorkItem}.
 * 2. Wraps the rows in a single `SmartCardProvider` so links resolve together.
 */
export function RecentWorkList({
	urls,
	maxSources = DEFAULT_MAX_SOURCES,
	onLinkClick,
	testId,
}: RecentWorkListProps): React.JSX.Element | null {
	if (urls.length === 0) {
		return null;
	}

	const visibleUrls = urls.slice(0, maxSources);

	return (
		<SmartCardProvider>
			<Stack space="space.050" testId={testId}>
				{visibleUrls.map((url, index) => (
					<RecentWorkItem
						key={`${url}-${index}`}
						url={url}
						index={index}
						onLinkClick={onLinkClick}
						testId={testId}
					/>
				))}
			</Stack>
		</SmartCardProvider>
	);
}
